import {
  Button,
  Tooltip,
  useComputedColorScheme,
  useMantineTheme,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconReceipt2 } from '@tabler/icons-react';

import { useSelectedClaimStore } from 'store/SelectedClaimStore';

interface InternalToggleClaimTotalsButtonProps {}

export const InternalToggleClaimTotalsButton: React.FC<
  InternalToggleClaimTotalsButtonProps
> = () => {
  const toolbarIconSize = 24;
  const toolbarButtonSize = 32;
  const computedColorScheme = useComputedColorScheme('dark');
  const theme = useMantineTheme();
  const isDesktopClaimTotalsViewport = useMediaQuery(
    `(min-width: ${theme.breakpoints.md})`
  );
  const { showClaimTotals, setShowClaimTotals } = useSelectedClaimStore();

  if (!isDesktopClaimTotalsViewport) return null;

  return (
    <Tooltip label="Toggle Claim Totals" position="top">
      <Button
        onClick={() => setShowClaimTotals(!showClaimTotals)}
        variant="subtle"
        size="xs"
        p={0}
        style={{
          width: toolbarButtonSize,
          height: toolbarButtonSize,
          minWidth: toolbarButtonSize,
        }}
        aria-label="Toggle claim totals"
        aria-pressed={showClaimTotals}
      >
        <IconReceipt2
          size={toolbarIconSize}
          color={computedColorScheme === 'dark' ? 'white' : 'black'}
        />
      </Button>
    </Tooltip>
  );
};
